import AuthAPI from './authInstance'

const createAPIUser = async (data) => {
  const response = await AuthAPI.post(`/admin/apis-users/add-user`, data)
  return response.data
}

const getAll = async () => {
  const response = await AuthAPI.get(`/admin/apis-users/list`)
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/apis-users/show/${data}`)
  return response.data
}

export const userService = {
  createAPIUser,
  getAll,
  getOne,
}
